export const GOOGLE_YES_BUTTON_VALUE = 1;
export const GOOGLE_NO_BUTTON_VALUE = 999;
